"use client";
import Navbar from "@/components/navbar";

export default function Tabs() {
  return (
    <div className="w-full sticky z-40 bg-backround top-0 px-2 border-b border-neutral-200">
      <Navbar sticky={false} />
    </div>
  );
}
